import { IProfileImgUploadConfig } from "../interface/IProfileImgUpload";

/**
 * @alias profileImgUpload
 * @category ProfileImgUpload
 * @param _config {IProfileImgUploadConfig} 
 * @example
 * if (window.ncui && window.ncui.profileImgUpload) {
 *    new window.ncui.profileImgUpload({
 *       createToken: "https://lineagew.plaync.com/kr/profile/image/token",
 *       isProfileUpload: true
 *    });
 * }
 */
export default class index {

    private charUpload: ICharUpload | null = null;

    constructor(_config: IProfileImgUploadConfig) {
        // console.log('-------ProfileImage START-------', _config);
        
        let charList = document.querySelector('.my-character-list');
        if (!charList) return;
        
        this.charUpload = new window.ui.ncUpload( _config );
        this.charUpload.onProfileComplete.add( ()=>location.reload(), this );
    }
}